interface DesktopAPI {
  getWappPanelIsFullscreen: () => boolean
  setWappPanelIsFullscreen: (isFullscreen: boolean) => void
}

export let desktopAppApi: DesktopAPI = {
  getWappPanelIsFullscreen: () => false,
  setWappPanelIsFullscreen() {},
}

export const setDesktopApi = (api: DesktopAPI) => {
  desktopAppApi = api
}
